var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1882_869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F8153B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1882_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 17.5L5.83333 11.6667V10H8.75C9.48611 10 10.1215 9.76042 10.6562 9.28125C11.191 8.80208 11.5139 8.20833 11.625 7.5H5V5.83333H11.375C11.1389 5.34722 10.7882 4.94792 10.3229 4.63542C9.85764 4.32292 9.33333 4.16667 8.75 4.16667H5V2.5H15V4.16667H12.2917C12.4861 4.40278 12.6597 4.65972 12.8125 4.9375C12.9653 5.21528 13.0833 5.51389 13.1667 5.83333H15V7.5H13.3125C13.2014 8.68056 12.7153 9.67014 11.8542 10.4688C10.9931 11.2674 9.95833 11.6667 8.75 11.6667H8.14583L13.75 17.5H11.4375Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.82421f2cab39706cc72fb3fa8dbb628f.svg";
export { ForwardRef as ReactComponent };